import { useEffect, useState } from "react";

import Scheduler from "./scheduler";
import { getAppointment } from "./service";
import { calculateDurationByWeight } from "lib/utils";

const Reschedule = ({
  id,
  close,
  takebackId,
  weight = 0,
  showDescription = false,
  location = "",
}) => {
  const [appointment, setAppointment] = useState(null);

  useEffect(() => {
    getAppointment(id).then(setAppointment);
  }, [id]);

  if (!appointment) return null;

  const duration = calculateDurationByWeight(weight);

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-4xl font-bold">Edit Appointment</h2>
          <button onClick={close} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        {showDescription && (
          <p className="text-tertiary mb-6">
            Based on your estimated trade-in quantity of {weight.toFixed(2)}{" "}
            lbs, your appointment at the LEGO® Store {location} will take
            approximately {duration} minutes.
          </p>
        )}

        <div className="font-bold">Choose a new time slot</div>

        <div className="mb-6">
          <Scheduler
            mode="edit"
            currentTime={appointment.time}
            appointmentId={id}
            onComplete={close}
            close={close}
            state={appointment.state}
            weight={appointment.weight}
            takebackId={takebackId}
            confirmLabel="Update Appointment"
          />
          {/* <div className="flex justify-between gap-2 px-6">
            <button className="border border-gray-300 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-100">
              Cancel
            </button>
            <button className="bg-blue-500 text-white px-4 py-2 rounded-full bg-blue-600">
              Confirm
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Reschedule;
